export default __webpack_public_path__ + "static/media/car-example-big.48d54a8b.png";